module.exports = __webpack_public_path__ + "img/re.d9a44fd6.svg";